// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"index-module--wrapper--3j17T","root":"index-module--root--1he-c","title":"index-module--title--xN2yf","intro":"index-module--intro--2Bzq-"};